module.exports = __webpack_public_path__ + "img/humberto-lay-sun.bfd3447d.png";